import React from "react";
import styled from "styled-components";
import { MainContainer } from "../../../assets/styles/theme/styles";
import theme from "../../../assets/styles/theme/theme";
import Heading from "../../../shared/Heading";
import Paragraph from "../../../shared/Paragraph";

const GridResPonsiveCards = ({ heading, cards }) => {
  return (
    <MainContainer>
      <Heading level={1} style={{ marginBottom: "2rem" }}>
        {heading}
      </Heading>
      <CardWrapper>
        {cards.map((card, index) => {
          return (
            <CardContainer key={index}>
              <CardBody>
                <Heading level={3}>{card.title}</Heading>
                <Paragraph level={2}>
                  <ul>
                    {card.body.map((val, i) => {
                      return <li key={i}>{val}</li>;
                    })}
                  </ul>
                </Paragraph>
              </CardBody>
            </CardContainer>
          );
        })}
      </CardWrapper>
    </MainContainer>
  );
};

export default GridResPonsiveCards;

const CardWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  grid-gap: 2rem;
  @media (min-width: 720px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // height: 277px;
  max-width: 305px;
  border-radius: 10px;
  // box-shadow: ${theme.shadows.hover};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  overflow: hidden;
  align-self: stretch;

  @media (min-width: 720px) {
    width: 100%;
  }
`;

const CardBody = styled.div`
  height: inherit;
  padding: 1.5rem;
  background-color: white;
  ul{

  }
  p {
    font-size: 1.1 rem;
    margin-bottom: 0px;
  }
}
`;
